import { render, staticRenderFns } from "./DirectMailTemp.vue?vue&type=template&id=9552ad00&scoped=true"
import script from "./DirectMailTemp.vue?vue&type=script&lang=js"
export * from "./DirectMailTemp.vue?vue&type=script&lang=js"
import style0 from "./DirectMailTemp.vue?vue&type=style&index=0&id=9552ad00&prod&lang=sass&scoped=true"
import style1 from "./DirectMailTemp.vue?vue&type=style&index=1&id=9552ad00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9552ad00",
  null
  
)

export default component.exports